import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { isClassicUI } from "./utils/uiVersion";

import { Provider } from "react-redux";
import configureEnvStore from "./store/configureEnvStore";
import "./i18n/root";
import api from "./services/apis/api";
import storage from "./utils/storage";

api.api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    // error.response is missing on network failures (server unreachable, blocked response)
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!originalRequest.url.includes("/token/refresh")) {
        try {
          const refreshToken = storage.get("refresh-token");
          if (refreshToken) {
            const response = await api.auth.callRefreshToken(refreshToken);
            const { access_token } = response;
            storage.set("token", access_token);
            // Retry the original request with the new token
            originalRequest.headers.Authorization = `Bearer ${access_token}`;
          } else {
            storage.clearAll();
            // window.location.reload();
            console.log("error", error);
          }

          return api.api(originalRequest);
        } catch (error) {
          console.log("error", error);
          storage.clearAll();
          window.location.reload();
        }
      } else {
        console.log("error");
        storage.clearAll();
        window.location.reload();
      }
    }

    return Promise.reject(error);
  },
);

// Load only the selected UI: the new UI (App + index.css) and the classic UI
// (AppV2 + indexV2.css) have conflicting global styles, so they must never
// be loaded on the same page. Switching UIs reloads the page.
//
// ── TO USE ONLY THE NEW UI (UI_V4) EXCLUSIVELY ──
// Change the line below to:
// const loadApp = () => import("./App");
// This permanently locks the application to the new UI (UI_V4) and disables the old AppV2.
const loadApp = isClassicUI() ? () => import("./AppV2") : () => import("./App");

const root = ReactDOM.createRoot(document.getElementById("root"));
loadApp().then(({ default: App }) => {
  root.render(
    <Provider store={configureEnvStore}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>,
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
